import classNames from 'classnames';
import { useRef, useState } from 'react';

import { slideUp, slideDown } from '~globals/common';
import Chevron from '~images/inline/chevron.inline.svg';

type IProps = {
    id: string;
    heading: string;
    excerpt: string;
} & { class?: string; [key: string]: string | boolean | undefined };

const DiscoveryTab = ({
    id,
    heading,
    children,
    excerpt,
    ...rest
}: React.PropsWithChildren<IProps>) => {
    delete rest.class;
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef(null as null | HTMLDivElement);
    id = id || `DiscoveryTab-${Math.random().toString(36).substring(2, 9)}`;

    const toggleContent = () => {
        if (!contentRef.current) {
            return;
        }
        isOpen ? slideUp(contentRef.current) : slideDown(contentRef.current);
        setIsOpen(!isOpen);
    };

    return (
        <div>
            <header
                className={
                    'border border-gray-dark bg-blue-lightest pl-3 py-6 pr-16 relative md:rounded-sm md:border-blue-sky md:p-5 mb-5'
                }
                data-qa="discoveryTab-row"
                {...rest}
            >
                <button
                    className="w-full flex items-center justify-between"
                    onClick={toggleContent}
                    aria-expanded={isOpen}
                    aria-controls={`btn-${id}`}
                    data-qa="discoveryTab-row"
                >
                    <div className="flex text-xl md:text-2xl leading-24 flex-col text-left">
                        <h3 className="font-bold">{heading}</h3>
                        <p className="text-lg leading-27 pr-4">{excerpt}</p>
                    </div>
                    <Chevron
                        aria-hidden="true"
                        data-qa="discoveryTab-arrow"
                        alt="arrow"
                        className={classNames(isOpen && 'transform rotate-180')}
                    />
                </button>
            </header>
            <div
                style={{ display: 'none' }}
                ref={contentRef}
                id={`content-${id}`}
                aria-labelledby={`btn-${id}`}
                className="py-4 px-1"
            >
                {children}
            </div>
        </div>
    );
};

export default DiscoveryTab;
